import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledCompaniesCountHighlight = styled(Flex)`
    flex-shrink: 0;
    padding: 8px 12px;
    border-radius: 8px;
    border: 1px solid ${colorsPalettes.carbon["100"]};
`;
